<template>
  <div class='container'>
    <div :class="['copy-right',isLoginPage?'copy-right-login':'']">
      <p class="copy-right-text">{{$t('copyright')}}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isLoginPage: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {

    }
  },

  components: {},

  computed: {},

  mounted() { },

  methods: {}
}

</script>

<style lang='scss' scoped>
.container {
}
.copy-right {
  display: flex;
  flex-direction: "row";
  justify-content: center;
  align-items: center;
  height: 0.5rem;
}
.copy-right-text {
  font-size: 0.1rem;
  color: #858585;
  font-weight: 500;
}
.copy-right-login {
  position: fixed;
  bottom: 0;
  text-align: center;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/layout/components/Footer.vue